export default __webpack_public_path__ + "static/media/gm-mg-girl.a5680f3a.webp";